var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoronaryArtery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.05137C7.04 5.51137 14.72 3.87137 21.21 5.85137",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.0616C6.34 15.2616 17.26 13.2716 20.71 15.5016",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.9216C2.5 11.9216 7.45 9.3916 8.46 9.6216C8.8 9.7016 10.08 9.9316 10.08 9.9316C11.44 10.2316 12.85 9.7716 13.77 8.7316C15.43 6.8516 20.71 8.5516 20.71 8.5516",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.7515C5.01 13.7315 7.78 12.9715 9.19 12.8115C9.68 12.7515 10.16 12.6215 10.6 12.4015C12.65 11.3915 13.59 11.8015 14.56 11.9215C16.09 12.1015 17.63 11.3015 20.7 12.5315",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87032 7.9516C9.85032 7.8616 10.0903 7.7716 10.1803 7.7516C10.3103 7.7116 10.5703 7.6416 10.7103 7.6416C10.7903 7.6416 11.0103 7.6916 11.0203 7.7616C11.0303 7.8616 10.7703 7.9716 10.6703 8.0016C10.5703 8.0316 10.3503 8.0416 10.2403 8.0516C10.1403 8.0516 9.88032 8.0416 9.87032 7.9516Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80957 10.2109C7.80957 10.2109 8.64957 11.2409 8.40957 12.6409",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5801 8.54102C15.5801 8.54102 16.1501 9.56102 15.9301 11.471",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73047 11.4912C3.73047 11.4912 4.86046 12.2612 4.38046 14.4012",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9805 8.11133C18.9805 8.11133 20.0305 9.71133 19.2705 11.6713",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.07168L12.95 6.97168",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoronaryArtery);
export default __webpack_public_path__ + "static/media/CoronaryArtery.d3b05b7f682a5b4233810f990bc1b484.svg";
export { ForwardRef as ReactComponent };